import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {IncomingActionsComponent} from './incoming-actions/incoming-actions.component';
import {OutgoingActionsComponent} from './outgoing-actions/outgoing-actions.component';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [IncomingActionsComponent, OutgoingActionsComponent],
  imports: [ CommonModule, NgbModalModule, FormsModule, ],
})
export class InOutActionsModule { }
